import React, { FunctionComponent } from 'react';
import { FinderAction } from '@/pages/visa-finder';
import { Link } from '@visalex/core';

import Image from 'next/image';

import commonStyles from '../Common/QuestionnairesCommon.module.scss';
import styles from './VisaFinder.module.scss';

const VisaFinderAction: FunctionComponent<FinderAction> = ({ url, label, description, RuleAction }) => (
  <div className={commonStyles.questionnaire__action}>
    <Image
      src={RuleAction === 'schedule' ? '/icons/icon-consultation.svg' : '/icons/get-visa.svg'}
      alt={label}
      width={90}
      height={90}
    />
    <h3 className={styles.questionnaire__label} data-testid="visa-action-title">
      {label}
    </h3>
    <p data-testid="visa-action-description">
      {RuleAction === 'schedule' ? description : description} {url && <Link href={url}>Learn more</Link>}
    </p>
  </div>
);

export default VisaFinderAction;
